<div class="add-curation-container">
<section class="Auto_Popup add-aberration-wrapper">
  <section class="override-item-as-row content">
    <gen-dynamic-form
      [formName]="selectedFormName"
      [formVertical]="true"
      (submitEmitter)="submit($event)"
      [submitted]="submitted"
      [popupMode]="true"
      (formChange)="updateForm($event.form)"
      (validateChange)="updateValidate($event)">
    </gen-dynamic-form>
  </section>
</section>
</div>
